export default __webpack_public_path__ + "media/convenience_product_3.e5b95847.png";